// export const billingCycleValues = [
//   {
//     value: "monthly",
//     label: "Monthly",
//   },
//   {
//     value: "quarterly",
//     label: "Quarterly",
//   },
//   //   {
//   //     value: "semiannually",
//   //     label: "Semiannually",
//   //   },
//   {
//     value: "yearly",
//     label: "Yearly",
//   },
// ];
// export const unitValues = [
//   {
//     value: "USD",
//     label: "USD",
//   },
//   {
//     value: "INR",
//     label: "INR",
//   },
//   {
//     value: "EUR",
//     label: "EUR",
//   },
// ];

// export const paymentTypeValues = [
//   {
//     value: "free",
//     label: "Free",
//   },
//   {
//     value: "paid",
//     label: "Paid",
//   },
// ];

export const billingCycleValues = [
  {
    value: "monthly",
    label: "Monthly",
  },
  {
    value: "quarterly",
    label: "Quarterly",
  },
  //   {
  //     value: "semiannually",
  //     label: "Semiannually",
  //   },
  {
    value: "yearly",
    label: "Yearly",
  },
];

export const unitValues = [
  {
    value: "USD",
    label: "USD",
  },
  {
    value: "INR",
    label: "INR",
  },
  {
    value: "EUR",
    label: "EUR",
  },
];

export const paymentTypeValues = [
  {
    value: "free",
    label: "Free",
  },
  {
    value: "paid",
    label: "Paid",
  },
];

export const customBillingUnitValues = [
  {
    value: "day",
    label: "Day(s)",
  },
  {
    value: "week",
    label: "Week(s)",
  },
  {
    value: "month",
    label: "Month(s)",
  },
  {
    value: "year",
    label: "Year(s)",
  },
];